module.exports = __webpack_public_path__ + "img/icon-differentials2_02.d83bdc7b.svg";